import chcSimplePage from "../modules/chcSimplePage";

class chcDefaultPage extends chcSimplePage {
    
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
    }
}

new chcDefaultPage();